import { useMessagingDirectMessagesChatCreate } from "@sidegigllc/api/client";
import { useNavigate } from "@tanstack/react-router";
import { useActiveLocationId } from "services/locationOrgContext";

export const useMessagePro = () => {
  const navigate = useNavigate();
  const [activeLocationId] = useActiveLocationId();
  const startChat = useMessagingDirectMessagesChatCreate();

  const messagePro = async (proId: number) => {
    if (!activeLocationId) return;
    const result = await startChat.mutateAsync({ data: { pro_id: proId, location_id: activeLocationId } });
    void navigate({
      to: "/locations/$locationId/inbox/chat/$channelUrl",
      params: { locationId: String(activeLocationId), channelUrl: result.channel_url },
    });
  };

  return { messagePro, isLoading: startChat.isPending };
};
